export default __webpack_public_path__ + "static/AeonikPro-Bold-15e2a8dc0de4de2544b55299bbe4b681.woff2";